<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.logradouro"
        ref="DataTable"
        sort-by="nome"
        search-by="nome"
        :disabled-button-search="true"
    >
        <template v-slot:cell(cep)="row">
            {{ row.value | formatCep }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-logradouro-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-logradouro"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-logradouro"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories.logradouro = this.getConectaSusRepository('cadastro.localizacao.logradouro')
    },
    data: () => ({
        fields: [
            {
                name: 'cadastroLogradouroTipo.descricao',
                key: 'logradouroTipoDescricao',
                label: 'Tipo',
                searchable: true,
                sortable: true
            },
            {
                name: 'nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroBairro.nome',
                key: 'bairroNome',
                label: 'Bairro',
                searchable: true,
                sortable: true
            },
            {
                name: 'cep',
                key: 'cep',
                label: 'CEP',
                searchable: true,
                sortable: true,
                class: 'col-min'
            },
            {
                name: 'cadastroMunicipio.nome',
                key: 'municipioNome',
                label: 'Município',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroEstado.uf',
                key: 'estadoUf',
                label: 'UF',
                searchable: true,
                sortable: true,
                class: 'col-min'
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            logradouro: null,
        },
    }),
    filters: {
        formatCep: formats.formatCep,
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.logradouro.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o logradouro?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>